var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1920 1080",
    width: 1920,
    height: 1080,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1920,
    height: 1080,
    fill: "#f9fafa"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "43.8%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#001122",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#001122",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "43.8%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#001122",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#465761",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "43.8%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#9aa5a9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#465761",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "43.8%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#9aa5a9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#f9fafa",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "56.3%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#001122",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#001122",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "56.3%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#465761",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#001122",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "56.3%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#465761",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#9aa5a9",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "0%",
    x2: "56.3%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#f9fafa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#9aa5a9",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1920, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 594C-110.1 582 -220.1 570 -297 514.4C-373.9 458.8 -417.6 359.5 -461.6 266.5C-505.6 173.5 -549.8 86.7 -594 0L0 0Z",
    fill: "#c8cfd0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 445.5C-82.5 436.5 -165.1 427.5 -222.7 385.8C-280.4 344.1 -313.2 269.6 -346.2 199.9C-379.2 130.1 -412.3 65.1 -445.5 0L0 0Z",
    fill: "#6e7d84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 297C-55 291 -110.1 285 -148.5 257.2C-186.9 229.4 -208.8 179.8 -230.8 133.3C-252.8 86.7 -274.9 43.4 -297 0L0 0Z",
    fill: "#223341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 148.5C-27.5 145.5 -55 142.5 -74.2 128.6C-93.5 114.7 -104.4 89.9 -115.4 66.6C-126.4 43.4 -137.4 21.7 -148.5 0L0 0Z",
    fill: "#001122"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 1080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -594C65.9 -513.8 131.9 -433.5 227.5 -394C323.1 -354.6 448.4 -355.9 514.4 -297C580.4 -238.1 587.2 -119.1 594 0L0 0Z",
    fill: "#c8cfd0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -445.5C49.5 -385.3 98.9 -325.1 170.6 -295.5C242.3 -265.9 336.3 -266.9 385.8 -222.8C435.3 -178.6 440.4 -89.3 445.5 0L0 0Z",
    fill: "#6e7d84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -297C33 -256.9 65.9 -216.8 113.7 -197C161.6 -177.3 224.2 -177.9 257.2 -148.5C290.2 -119.1 293.6 -59.5 297 0L0 0Z",
    fill: "#223341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -148.5C16.5 -128.4 33 -108.4 56.9 -98.5C80.8 -88.6 112.1 -89 128.6 -74.3C145.1 -59.5 146.8 -29.8 148.5 0L0 0Z",
    fill: "#001122"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLight);
export default __webpack_public_path__ + "static/media/bg_light.6cbeae08decc8127a16339a956e149fb.svg";
export { ForwardRef as ReactComponent };